<template>
    <div class="container-fluid" style="padding: 0px; overflow: hidden;">
        <div class="row">
            <div class="col">
                <div class="hero_banner">
                    <h2>Terms & Conditions</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="container term_container">
        <div class="mt-5 gradient_border py-4 rounded shadow-lg container scroll_container">
            <div class="row">
                <div class="col-md-12">
                    <p class="text-muted mb-4">
                        <span class="underline text_bold">YOUR RIGHTS AND OBLIGATIONS.</span>You may access and use the
                        sleep health screener over the internet from any connected computer. You assume full
                        responsibility
                        for the selection of and use of the screener. You (or any associate) may not copy, modify,
                        translate, reverse engineer, decompile, reverse‐compile, or translate the Hypknowledge sleep
                        health
                        screener (text or code). If you wish to use the screener for professional (e.g., clinical
                        practice),
                        research (funded or unfunded investigations), or institutional purposes (e.g., as an instrument
                        within an established EMR), please contact <a href="https://www.hypknowledge.com/"
                            target="_blank" class="font-weight-bold">Hypknowledge LLC</a><span class="mx-2">or</span><a
                            href="https://eprovide.mapi-trust.org/" target="_blank" class=" font-weight-bold">eProvide /
                            The
                            MAPI trust</a>
                    </p>
                    
                    <p class="text-muted mb-4">The sleep health screener (SDSCL-25) is a decision support tool to help
                        users
                        assess their sleep health. It is not a substitute for professional medical advice, diagnosis, or
                        treatment. Links are provided to established informational sources that may guide you towards
                        securing clinical services. Any information you provide is gathered for your use and your
                        de-identified data will be used to improve the sleep health screener and for research purposes.
                    </p>
                    <p class="text-muted mb-4"><span class="underline text_bold">AGREEMENT.</span>The sleep health
                        screener
                        tool to which you are being given access is not being sold to you. You are granted use of the
                        screener solely for your personal use. The screener is provided “as-is” without any warranties
                        of
                        any kind. Access to the screener and this website is provided by Hypknowledge with unrestricted
                        financial support from</p>
                    <ul class="terms_list">
                        <li>
                            <a href="https://api.sleephealthscreen.com/api/sponsor/Avadel%20Pharmaceuticals"
                                target="_blank">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                                    height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z">
                                    </path>
                                </svg> Avadel Pharmaceuticals
                            </a>
                        </li>
                        <li>
                            <a href="https://api.sleephealthscreen.com/api/sponsor/Harmony%20Biosciences"
                                target="_blank">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                                    height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z">
                                    </path>
                                </svg> Harmony Biosciences
                            </a>
                        </li>
                        <li>
                            <a href="https://api.sleephealthscreen.com/api/sponsor/Jazz%20Pharmaceuticals"
                                target="_blank">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                                    height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z">
                                    </path>
                                </svg> Jazz Pharmaceuticals
                            </a>
                        </li>
                        <li>
                            <a href="https://api.sleephealthscreen.com/api/sponsor/Takeda%20Pharmaceuticals"
                                target="_blank">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                                    height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z">
                                    </path>
                                </svg> Takeda Pharmaceuticals
                            </a>
                        </li>
                    </ul>


                </div>
            </div>
        </div>
        <div class="button_wrapper terms d-flex justify-content-center mt-4">
            <button type="button" class="MuiButton-contained">Accept </button><button type="button"
                class="MuiButton-contained danger_btn" style="background-color: rgb(220, 53, 69);">Decline
            </button>
        </div>
    </div>
</template>

<script>


export default {
    name: 'TermsConditionPage',
    components: {
    },

};
</script>

<style scoped>
.scroll_container {
    height: 220px;
    overflow-y: scroll;
}

.button_wrapper.terms {
    justify-content: center;
    gap: 30px;
    flex-direction: row;
    align-items: center;
}

.hero_banner {
    background-image: url(../assets/description_banner.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 200px;
    box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 35%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.hero_banner h2 {
    color: #ffffff;
    font-size: 40px;
}

ul.terms_list {
    padding: 0;
    list-style: none;
}

.underline {
    text-decoration: underline;
}

.text_bold {
    font-weight: 500;
}

.gradient_border {
    border-radius: 10px;
    border: 1px solid #e0e0e0;
    background-color: #fafafa;
}

.terms_list li {
    margin-bottom: 15px;
}

@media screen and (min-width: 768px) {
    .term_container {
        min-height: 450px;
    }
}

@media screen and (max-width: 767px) {

    .terms_banner h2,
    .hero_banner h2 {
        font-size: 30px;
        text-align: center;
    }

    .hero_banner {
        height: 150px;
    }

}
</style>